import Vue from 'vue'
import VueRouter from 'vue-router'
import { urldecode } from '@/assets/js/utils'

const Home = () => import(/* webpackChunkName: "Home" */ '@/views/Home.vue')
const Live = () => import(/* webpackChunkName: "Live" */ '@/views/Live.vue')
const DocumentDetail = () => import(/* webpackChunkName: "DocumentDetail" */ '@/views/DocumentDetail.vue')
const DocumentPreview = () => import(/* webpackChunkName: "DocumentPreview" */ '@/views/DocumentPreview.vue')
const LivePreview = () => import(/* webpackChunkName: "LivePreview" */ '@/views/LivePreview.vue')
const ColumnDetail = () => import(/* webpackChunkName: "ColumnDetail" */ '@/views/ColumnDetail.vue')
const TopicDetail = () => import(/* webpackChunkName: "TopicDetail" */ '@/views/TopicDetail.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Live',
    name: 'Live',
    component: Live
  },
  {
    path: '/DocumentDetail',
    name: 'DocumentDetail',
    component: DocumentDetail
  },
  {
    path: '/DocumentPreview',
    name: 'DocumentPreview',
    component: DocumentPreview
  },
  {
    path: '/LivePreview',
    name: 'LivePreview',
    component: LivePreview
  },
  {
    path: '/ColumnDetail',
    name: 'ColumnDetail',
    component: ColumnDetail
  },
  {
    path: '/TopicDetail',
    name: 'TopicDetail',
    component: TopicDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.auth) {
    sessionStorage.setItem('LYH_JSLOGIN_AUTH_KEY', urldecode(to.query.auth))
  }
  if (to.query.sou) sessionStorage.setItem('LYH_JSLOGIN_SOURCE', to.query.sou)
  next()
})

router.afterEach((to, from) => {
  // if (isApp()) {
  //   JSCallNative('hideRightNavigationBarButton')
  // }
})

export default router
